class BlogSort extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector(this.dataset.target);
    this.addEventListener('change', this.onSortChange.bind(this));
  }

  onSortChange(event) {
    if (event.target.name !== 'blog_sort_by') return;

    this.sortArticles(event.target.value);

    this.querySelectorAll('.sort-option').forEach((label) => {
      label.classList.toggle('active', label.querySelector('input').checked);
    });

    const labelEl = this.querySelector('[data-sort-current-label]');
    if (labelEl) labelEl.textContent = event.target.dataset.sortLabel;

    const details = this.querySelector('details');
    if (details) details.removeAttribute('open');
  }

  sortArticles(value) {
    if (!this.container) return;

    const items = Array.from(this.container.children);
    const getDate = (el) => new Date(el.dataset.publishedAt).getTime();
    const getTitle = (el) => (el.dataset.title || '').toLowerCase();

    items.sort((a, b) => {
      switch (value) {
        case 'oldest':
          return getDate(a) - getDate(b);
        case 'title-asc':
          return getTitle(a).localeCompare(getTitle(b));
        case 'title-desc':
          return getTitle(b).localeCompare(getTitle(a));
        case 'newest':
        default:
          return getDate(b) - getDate(a);
      }
    });

    items.forEach((item) => this.container.appendChild(item));
  }
}

customElements.define('blog-sort', BlogSort);
